<div *ngIf="viewState === 'VALUES' && displayRefreshState" class="p-d-flex p-jc-between p-ai-center">
    <label class="p-m-0">{{refreshing ? 'Loading' : 'Last updated ' + (refreshDate | date: 'MM/dd/yyyy HH:mm:ss')}}</label>
    <button pButton (click)="refresh()" icon="pi {{refreshing ? 'pi-spinner pi-spin' : 'pi-refresh'}}" [disabled]="refreshing"></button>
</div>
<div *ngIf="refreshing && !displayRefreshState" class="p-text-center" >
    <p-progressSpinner></p-progressSpinner>
</div>
<ng-container *ngIf="!refreshing && !values.length">
    <div class="p-text-center">
        <label>No past values to display</label>
    </div>
</ng-container>
<ng-container *ngIf="!refreshing && values.length">
    <ng-container [ngSwitch]="viewState">

        <ng-container *ngSwitchCase="'VALUES'" [ngSwitch]="state">
            <div class="p-d-flex p-jc-center" *ngIf="showPath">
                <label class="p-d-flex p-flex-column p-jc-center p-text-center">
                    <span>{{note.templateName}}</span>
                    <span>{{templateSegment.longName}}</span>
                </label>
            </div>
            <div *ngIf="isChartable" class="p-d-flex p-jc-center p-ai-center p-my-1">
                <p-selectButton [options]="stateOptions" [(ngModel)]="state" optionLabel="label" optionValue="value"></p-selectButton>
            </div>

            <p-table *ngSwitchCase="'TABLE'" tableStyleClass="past-values-table" [value]="values" dataKey="key">
                <ng-template pTemplate="body" let-entry let-expanded="expanded">
                    <tr [title]="entry.isContextValue ? 'Current value from which the shown history is based' : ''" [class]="{ highlight: entry.isContextValue }">
                        <td lb-events (afterViewInit)="setOutOfRangeAttribute($event, entry.outOfRange)">
                            <div>
                                <ng-container [ngSwitch]="templateSegmentType">
                                    <ng-container *ngSwitchCase="SEGMENT_TYPES.FILE_ATTACHMENT">
                                        <ng-container *ngIf="typeOf(entry.value) === 'string'; else fileListing">
                                            {{entry.value}}
                                        </ng-container>
                                        <ng-template #fileListing>
                                            <div>
                                                <lb-file-detail-listing *ngFor="let file of entry.value" [file]="file"></lb-file-detail-listing>
                                            </div>
                                        </ng-template>
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>
                                        <ng-container *ngIf="entry.mustRender">
                                            <div class="value-render">
                                                <div [innerHtml]="entry.value | trustHtml"></div>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="!entry.mustRender">
                                            {{entry.value}}{{entry.ntv != null ? unitsDisplay : ''}}
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                                <div *ngIf="entry.comment || entry.attachments.length" class="p-d-flex p-ai-baseline">
                                    <button type="button" pButton pRipple
                                            class="p-button-link comment-toggle"
                                            [pRowToggler]="entry"
                                            label="Comments"
                                            [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
                                    </button>
                                </div>
                            </div>
                        </td>
                        <td class="p-text-right" lb-events (afterViewInit)="setOutOfRangeAttribute($event, entry.outOfRange)">
                            <a *ngIf="!entry.isContextValue" title="View note preview" (click)="displayNote('TABLE', $event, notePanel, entry.note)" [href]="entry.detailHref">{{entry.date | date: 'MM/dd/yyyy HH:mm'}}</a>
                            <span *ngIf="entry.isContextValue">{{entry.date | date: 'MM/dd/yyyy HH:mm'}}</span>
                            <p-overlayPanel #notePanel appendTo="body" (onShow)="attemptScrollToSegment(noteTableContainer)">
                                <div class="p-d-flex p-jc-between p-ai-center p-mb-2">
                                    <label class="p-m-0">{{entry.date | date: 'MM/dd/yyyy HH:mm'}}</label>
                                    <span class="p-d-flex p-jc-between p-ai-center">
                                        <a title="Open note in new window" [href]="entry.detailHref" target="_blank" class="pi pi-external-link p-mr-4"></a>
                                        <a title="Close note preview" class="pi pi-times" (click)="notePanel.hide()"></a>
                                    </span>
                                </div>
                                <div lb-events
                                     #noteTableContainer
                                     (afterViewInit)="updateLinkListener(entry.note.id, $event)"
                                     (onDestroy)="updateLinkListener(entry.note.id)"
                                     [style]="{maxHeight: maxNoteHeight}"
                                     class="note-preview-container">
                                    <lb-note [note]="entry.note"></lb-note>
                                </div>
                            </p-overlayPanel>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="rowexpansion" let-entry>
                    <tr>
                        <td class="p-pt-0" colspan="2">
                            <ng-container *ngTemplateOutlet="attachmentEntry; context: { $implicit: entry }"></ng-container>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
            <div *ngSwitchCase="'CHART'" class="p-text-center">
                <p-chart (onDataSelect)="displayNote('CHART', $event, chartPanel, null)" [type]="chartType" [data]="chartData" [options]="chartOptions"></p-chart>
                <p-overlayPanel #chartPanel appendTo="body" (onShow)="attemptScrollToSegment(noteTableContainer); updateChartLinkListener(noteTableContainer)" (onHide)="updateChartLinkListener()">
                    <div class="p-d-flex p-jc-between p-ai-center p-mb-2">
                        <label class="p-m-0">{{chartNoteDetail.date | date: 'MM/dd/yyyy HH:mm'}}</label>
                        <span class="p-d-flex p-jc-between p-ai-center">
                            <a title="Open note in new window" [href]="chartNoteDetail.href" target="_blank" class="pi pi-external-link p-mr-4"></a>
                            <a title="Close note preview" class="pi pi-times" (click)="chartPanel.hide()"></a>
                        </span>
                    </div>
                    <div #noteTableContainer [style]="{maxHeight: maxNoteHeight}" class="note-preview-container">
                        <lb-note *ngIf="chartNoteDetail.note" [note]="chartNoteDetail.note"></lb-note>
                    </div>
                </p-overlayPanel>
            </div>

        </ng-container>

        <ng-container *ngSwitchCase="'NOTE'">
            <ng-container *ngIf="noteToDetail">
                <div [style]="{maxHeight: maxNoteHeight}" class="note-preview-container" lb-events (afterViewInit)="attemptScrollToSegment($event)" >
                    <lb-note [noteEdit]="'DIALOG'" [note]="noteToDetail"></lb-note>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
</ng-container>

<ng-template #attachmentEntry let-entry>
    <p-card>
        {{entry.comment ? entry.comment : 'No Comment Provided'}}
        <p-table [value]="entry.attachments">
            <ng-template pTemplate="body" let-attachment>
                <tr>
                    <td class="p-px-0">
                        <lb-file-detail-listing [file]="attachment" [siblings]="entry.attachments"></lb-file-detail-listing>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </p-card>
</ng-template>
